import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid ${(p) => p.theme.tokens.colors.line};
  font-family: ${(p) => p.theme.tokens.font.family};

  &:last-child {
    border-bottom: none;
  }
`;

export const Thumb = styled.div`
  width: 60px;
  height: 60px;
  flex-shrink: 0;
`;

export const Info = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Name = styled.div`
  font-weight: 800;
  font-size: 14px;
  color: ${(p) => p.theme.tokens.colors.ink};
  line-height: 1.25;
`;

export const ExtrasLine = styled.div`
  font-size: 11.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 3px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const BottomLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
`;

export const Qty = styled.span`
  background: ${(p) => p.theme.tokens.colors.bg};
  border-radius: ${(p) => p.theme.tokens.radii.sm}px;
  padding: 3px 9px;
  font-weight: 800;
  font-size: 12.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const Price = styled.span`
  font-weight: 900;
  font-size: 14.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const RemoveButton = styled.button`
  align-self: flex-start;
  border: none;
  background: none;
  color: ${(p) => p.theme.tokens.colors.disabledText};
  cursor: pointer;
  padding: 2px;
  margin-top: 2px;
  flex-shrink: 0;
`;
